import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { CircuitTraces } from './CircuitTraces';
import { SignalWaves } from './SignalWaves';
import { BlueprintGrid } from './BlueprintGrid';
export function Footer() {
  return <footer className="relative bg-navy grain overflow-hidden text-white py-16 px-6" data-id="element-73">
      {/* Motif layers */}
      <div className="absolute inset-0 text-white/[0.15] mix-blend-soft-light" data-id="element-74">
        <BlueprintGrid data-id="element-75" />
      </div>
      <div className="absolute inset-0 text-white/[0.12]" data-id="element-76">
        <CircuitTraces data-id="element-77" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy/20 via-transparent to-navy/30" data-id="element-78" />

      <div className="relative max-w-7xl mx-auto z-10 space-y-10" data-id="element-79">
        {/* Row 1: Brand */}
        <div data-id="element-80">
          <div className="flex items-center gap-5 mb-3" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/pCtzMmZ2ci5LGu7D7o9MNa/GTH_Logo_(3).png" alt="Growth That Holds mark" className="h-14 w-auto brightness-0 invert opacity-90" data-id="element-82" />
            <div className="w-px h-10 bg-seaglass/40" data-id="element-83" />
            <div data-id="element-84">
              <h3 className="text-2xl font-serif font-semibold text-white tracking-[0.25em] uppercase leading-tight" data-id="element-85">
                Growth
              </h3>
              <p className="text-[0.85rem] font-serif font-medium text-white/80 tracking-[0.43em] uppercase leading-tight" data-id="element-86">
                That Holds
              </p>
            </div>
          </div>
          <p className="text-sm text-white/60" data-id="element-87">
            Business architecture for founder-led companies
          </p>
        </div>

        {/* Row 2: Nav links — horizontal strip */}
        <div className="border-t border-white/10 pt-10" data-id="element-88">
          <p className="eyebrow text-white/40 mb-5" data-id="element-89">Navigate</p>
          <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-90">
            {[{
            label: "What's Wrong",
            to: '/whats-wrong'
          }, {
            label: 'How We Fix It',
            to: '/how-we-fix-it'
          }, {
            label: 'Where AI Fits',
            to: '/where-ai-fits'
          }, {
            label: 'About John',
            to: '/about-john'
          }, {
            label: 'Book a Conversation',
            to: '/book'
          }].map(link => <li key={link.to} data-id="element-91">
                <Link to={link.to} className="text-sm text-white/70 hover:text-white transition-colors duration-300" data-id="element-92">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {/* Row 3: Contact + copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-93">
          <a href="mailto:john@growththatholds.com" className="flex items-center space-x-2 text-sm text-white/70 hover:text-white transition-colors duration-300 group" data-id="element-94">
            <Mail className="w-4 h-4 group-hover:text-seaglass transition-colors duration-300" data-id="element-95" />
            <span data-id="element-96">john@growththatholds.com</span>
          </a>
          <p className="text-sm text-white/40" data-id="element-97">
            &copy; {new Date().getFullYear()} Growth That Holds. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}